module.exports = __webpack_public_path__ + "static/media/companyculture01.25467b16.png";